import { Box, Stack, Typography } from '@mui/material';
import TwoFactorSection from './TwoFactorSection';

export default function TwoFactorAuthPage() {
  return (
    <Box sx={{ maxWidth: 960, mx: 'auto', p: { xs: 2, md: 3 } }}>
      <Stack spacing={3}>
        <Typography variant="h4" component="h1">
          Account Security
        </Typography>
        <TwoFactorSection />
      </Stack>
    </Box>
  );
}
